import { Helmet } from 'react-helmet-async';
// @mui
import { Container } from '@mui/material';
// routes
import { PATH_MASTERDATA } from '../../../routes/paths';
// components
import { useSettingsContext } from '../../../components/settings';
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs';
// sections
import UserNewEditForm from '../../../sections/@dashboard/user/UserNewEditForm';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import siteAPI from 'src/api/siteAPI';
import SiteNewEditForm from 'src/sections/@dashboard/sites/SiteNewEditForm';

// ----------------------------------------------------------------------

export default function SiteEditPage() {
    const { themeStretch } = useSettingsContext();
    const [site, setSite] = useState(null);
    const { id } = useParams();
    useEffect(() => {
        const getDetail = async () => {
            try {
                const response = await siteAPI.getSiteById(id);
                setSite(response.data);
            } catch (error) {
                console.error(error);
            }
        };
        getDetail();
    }, [id]);

    return (
        <>
            <Helmet>
                <title> Site: Edit site</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'lg'}>
                <CustomBreadcrumbs
                    heading="Edit existing site"
                    links={[
                        { name: 'Master Data', href: PATH_MASTERDATA.root },
                        { name: 'Site', href: PATH_MASTERDATA.site },
                        { name: 'Edit site' },
                    ]}
                />
                <SiteNewEditForm isEdit currentSite={site} />
            </Container>
        </>
    );
}
